module.exports = __webpack_public_path__ + "img/gleam-hero_mob.e721fdc.webp";